/* @flow */
import getElementoPorId from '../../utils/get-elemento-por-id';

const mostrarResultadoVazio = (params: Object) => {
    const html = `
        <div class="text-center">
            <img
                src="/theme/dist/html/default/assets/app/media/img/misc/caixa-vazia.png"
                class="img-fluid">

            <h5 class="m-portlet__head-text text-center">${params.msg}</h5>
        </div>`;

    getElementoPorId(params.id).innerHTML = html;
};

export default mostrarResultadoVazio;
